var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopwatchInCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.7688,
    r: 20,
    fill: "#FCDBE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5605 8.7688V10.775H18.5959V11.7781C19.3083 11.6778 19.9189 11.6778 20.6313 11.7781V10.775H22.6666V8.7688H16.5605Z",
    fill: "#ED0C2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4285 31.6423C24.478 31.6423 28.5714 27.6076 28.5714 22.6304C28.5714 17.6533 24.478 13.6186 19.4285 13.6186C14.3791 13.6186 10.2857 17.6533 10.2857 22.6304C10.2857 27.6076 14.3791 31.6423 19.4285 31.6423ZM19.4285 32.7688C25.1092 32.7688 29.7142 28.2297 29.7142 22.6304C29.7142 17.0312 25.1092 12.4921 19.4285 12.4921C13.7479 12.4921 9.14282 17.0312 9.14282 22.6304C9.14282 28.2297 13.7479 32.7688 19.4285 32.7688Z",
    fill: "#ED0C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5339 15.3892L27.2463 14.687L28.0604 15.4895L29.4852 14.0852L26.4322 11.0759L25.0074 12.4802L25.8216 13.2827L24.9057 14.1855C20.0208 11.2765 30.0958 18.5991 26.5339 15.3892V15.3892Z",
    fill: "#ED0C2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M19.4146 14.8682C23.5172 14.8682 26.8431 18.1465 26.8431 22.1904C24.4026 22.1904 23.5172 22.1904 19.4146 22.1904C19.4146 19.2283 19.4146 18.2178 19.4146 14.8682Z",
    fill: "#ED0C2F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatchInCircle);
export default __webpack_public_path__ + "static/media/stopwatch-in-circle.edf15e26373d10fd8fe4cdc7efad6144.svg";
export { ForwardRef as ReactComponent };